import commonEs from "@/core/common/internationalization/dictionaries/common-es";
import domainEs from "@/core/common/internationalization/dictionaries/domain-es";
import navigationEs from "@/core/common/internationalization/dictionaries/navigation-es";

export default {
  common: commonEs,
  navigation: navigationEs,
  domain: domainEs,
};
